module.exports = __webpack_public_path__ + "static/media/121.1a3e9813.jpg";